<template>
    <van-row class="header_container">
        <van-col span="3" class="header_col">
            <img src="@/assets/common/icon_back.png" alt="" @click="handleBackClick">
        </van-col>
        <van-col span="18" class="header_col">
            {{ props.text }}
        </van-col>
        <van-col span="3" class="history-col" v-if="showHistory">
            <div @click="() => emits('openHistoryPopup')">
                {{ $t('common.history') }}
                <van-icon name="play" style="padding-top: 2px;" />
            </div>
        </van-col>
    </van-row>
</template>

<script setup lang="ts">
import { navToBack } from '@/view/components/supportFunction'
import { defineProps, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const props = defineProps({
    text: {
        type: String,
        default: () => ''
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    isPopupCloseBackIcon: {
        type: Boolean,
        default: () => false
    },
    showHistory: {
        type: Boolean,
        default: () => false
    }
})
const emits = defineEmits(['closePopup', 'openHistoryPopup'])

const handleBackClick = () => {
    navToBack(router, props.isPopupCloseBackIcon, emits)
}

</script>
<style scoped>
.header_container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #27190D !important;
    color: #ffffffd9;
    padding: 5px 12px;
    z-index: 1000;
}

.header_col img {
    width: 40px;
}

.header_col {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}

.history-col {
    font-size: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    text-align: center;
}
</style>